import React from 'react'
import { render } from 'react-dom'
import registerServiceWorker from './registerServiceWorker'

import './css/index.css';
import './css/App.css';
import './css/contextMenu.css';
import './css/sfm.css';
import store from './js/store/'
import Root from './js/components/Root';

window.store = store;

render(
  <Root store={store} />,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js